import { T as ToggleWrapper, a as ToggleLabel, b as ToggleBase, c as ToggleSwitch, d as ToggleLabelText, m as media } from './hideScrollbar-be724272.js';
export { S as ScreenSize, j as Textfield, I as TextfieldInput, k as TextfieldSymbol, V as ValidationMessage, g as darken, e as focus, f as font, i as getBreakpoints, h as hideScrollbar, m as media, t as typography } from './hideScrollbar-be724272.js';
import { a as applyColor, E as Ellipsis, b as EllipsisWithLineClamp } from './ThemeProvider-9067c947.js';
export { E as Ellipsis, b as EllipsisWithLineClamp, T as ThemeProvider, l as lighten, t as theme } from './ThemeProvider-9067c947.js';
import { B as Button, L as LoadingSpinner } from './Modal-a5d8faed.js';
export { a as BlurFilter, B as Button, C as Column, L as LoadingSpinner, c as LoadingWarren, M as Modal, R as Row, b as buttonCSS, l as loadingAnimation } from './Modal-a5d8faed.js';
import { jsx, jsxs } from 'react/jsx-runtime';
import * as React from 'react';
import { useState, useRef, useCallback, useEffect, isValidElement, cloneElement, forwardRef, Children, createContext, useContext, useMemo } from 'react';
export { C as CrossSolid } from './CrossSolid-64fcb13f.js';
import styled, { css, keyframes } from 'styled-components';
import { u as useTheme } from './useMount-d50487b3.js';
export { b as useIsMounted, a as useMount, u as useTheme } from './useMount-d50487b3.js';
import { S as SuccessSolid, W as WarningSolid, D as DangerSolid } from './WatchlistSolid-6232c7ee.js';
export { A as AddToListSolid, a as AddToPortfolioOutline, b as AngledCollapseSolid, c as AngledExpandSolid, d as AnnouncementOutline, e as ArrowRightSolid, f as ArticleOutline, B as BellRingingSolid, g as BinSolid, h as BoardMembersOutline, i as BoldTextSolid, j as BulletListSolid, C as CalendarOutline, k as ChartStandOutline, l as CheckSolid, m as ChevronDownSmallSolid, n as ChevronLeftEndSolid, o as ChevronLeftSolid, p as ChevronRightEndSolid, q as ChevronRightSmallSolid, r as ChevronRightSolid, s as CompanyOutline, t as CopyLinkOutline, D as DangerSolid, u as DiscoverOutline, v as DiscoverSolid, w as DownSolid, x as DownloadImageSolid, y as DownloadPdfSolid, z as DownloadReportSolid, E as DownloadXlsSolid, F as EditOutline, G as EditSolid, H as ExecutiveOutline, I as ExecutiveSmallOutline, J as ExpandSolid, K as EyeSolid, L as FilterOutline, M as FvOutline, N as FvSolid, O as HeadingTextSolid, P as HomeOutline, Q as HomeSolid, R as ImageUploadOutline, T as InfoDescriptionSolid, U as InformationSolid, V as ItalicTextSolid, X as LineDownOutline, Y as LineUpOutline, Z as LinkOutline, _ as ListSolid, $ as LockSolid, a0 as MarketInsightsOutline, a1 as MenuSolid, a2 as MoreHorizontalBoldOutline, a3 as MoreHorizontalBoldSolid, a4 as MoreHorizontalSolid, a5 as MoreVerticalSolid, a6 as NotesOutline, a7 as NotificationOutline, a8 as OpenNewWindowOutline, a9 as PlusSolid, aa as PortfolioOutline, ab as PortfolioSolid, ac as QuestionMarkOutline, ad as ResetSolid, ae as RewardSolid, af as ScreenerOutline, ag as ScreenerSolid, ah as SearchSolid, ai as ShareOutline, aj as SidebarOutline, ak as SmileyNeutralSolid, al as SortingOutline, aq as StarOutline, ar as StarSolid, am as StatementNegativeSolid, an as StatementNoDataSolid, ao as StatementPositiveSolid, ap as StatementWarningSolid, as as StocksOutline, at as StocksSolid, S as SuccessSolid, au as SupportSolid, av as TableSolid, aw as TickSolid, ax as TilesSolid, ay as TransferSolid, az as UserOutline, W as WarningSolid, aA as WatchlistOutline, aB as WatchlistSolid } from './WatchlistSolid-6232c7ee.js';
export { default as BoardChangeOutline } from './BoardChangeOutline.esm.js';
export { default as BreakEvenOutline } from './BreakEvenOutline.esm.js';
export { default as ChartDownOutline } from './ChartDownOutline.esm.js';
export { default as ChartUpOutline } from './ChartUpOutline.esm.js';
export { default as DividendOutline } from './DividendOutline.esm.js';
export { default as EarningReportOutline } from './EarningReportOutline.esm.js';
export { default as ExecutiveLeavingOutline } from './ExecutiveLeavingOutline.esm.js';
export { default as ExecutiveOverboardingOutline } from './ExecutiveOverboardingOutline.esm.js';
export { default as ForecastDowngradeOutline } from './ForecastDowngradeOutline.esm.js';
export { default as ForecastOutline } from './ForecastOutline.esm.js';
export { default as ForecastUpgradeOutline } from './ForecastUpgradeOutline.esm.js';
export { default as InsiderDownOutline } from './InsiderDownOutline.esm.js';
export { default as InsiderUpOutline } from './InsiderUpOutline.esm.js';
export { default as NewRiskOutline } from './NewRiskOutline.esm.js';
export { default as PeOutline } from './PeOutline.esm.js';
export { default as PriceDownOutline } from './PriceDownOutline.esm.js';
export { default as PriceUpOutline } from './PriceUpOutline.esm.js';
export { default as ValuationOutline } from './ValuationOutline.esm.js';
export { u as usePreventWindowScroll } from './usePreventWindowScroll-c5154532.js';
import 'react-dom';

const Toggle = _ref => {
  let {
    name,
    value,
    label,
    tabIndex,
    readOnly,
    autoFocus,
    disabled = false,
    onChange,
    onFocus,
    onBlur,
    styleType = 'dark',
    display = 'inline-block'
  } = _ref;
  return jsx(ToggleWrapper, {
    disabled: disabled,
    display: display,
    children: jsxs(ToggleLabel, {
      "data-cy-id": `toggle-label-${name}`,
      children: [jsx("input", {
        name: name,
        type: "checkbox",
        checked: value,
        disabled: disabled,
        readOnly: readOnly,
        autoFocus: autoFocus,
        tabIndex: tabIndex || 0,
        onBlur: onBlur,
        onFocus: onFocus,
        onChange: e => {
          onChange && onChange(e);
        },
        "data-cy-id": `toggle-btn-${name}`
      }), jsx(ToggleBase, {
        styleType: styleType,
        children: jsx(ToggleSwitch, {})
      }), label ? jsx(ToggleLabelText, {
        children: label
      }) : null]
    })
  });
};

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}

const ButtonWrapper = styled('div')`
  display: inline-block;
  width: auto;
  position: relative;
`;
const DropdownWrapper = styled('div')`
  position: absolute;
  width: 100%;
  ${_ref => {
  let {
    dropUp
  } = _ref;
  return dropUp && css`
      top: 0;
    `;
}};
`;
const Dropdown = styled('div')`
  position: absolute;
  z-index: 1;
  ${_ref2 => {
  let {
    dropUp,
    marginTop,
    marginBottom,
    theme
  } = _ref2;
  if (dropUp) {
    return css`
        bottom: ${marginTop ? 0 : theme.x1spacePx / 2}px;
      `;
  }
  return css`
      top: ${marginBottom ? 0 : theme.x1spacePx / 2}px;
    `;
}};
  ${_ref3 => {
  let {
    floatLeft,
    marginLeft,
    marginRight,
    theme
  } = _ref3;
  return floatLeft ? css`
          left: ${marginLeft ? theme.x1spacePx / 2 : 0}px;
        ` : css`
          right: ${marginRight ? theme.x1spacePx / 2 : 0}px;
        `;
}};
  background: white;
  border: 1px solid ${_ref4 => {
  let {
    theme
  } = _ref4;
  return theme.color.whiteRGBA(0.5);
}};
  padding: ${_ref5 => {
  let {
    theme
  } = _ref5;
  return theme.x1spacePx;
}}px 0;
  border-radius: 4px;
  > hr {
    margin: 8px 0;
    border-top: 1px solid ${_ref6 => {
  let {
    theme
  } = _ref6;
  return theme.color.lightGray;
}};
  }
  display: inline-block;
  width: auto;
`;
const DropdownButton = styled('button')`
  ${_ref7 => {
  let {
    theme
  } = _ref7;
  return theme.typography.xSmall;
}};
  color: ${_ref8 => {
  let {
    theme
  } = _ref8;
  return theme.color.black;
}};
  display: flex;
  align-items: center;
  white-space: nowrap;
  user-select: none;
  text-decoration: none;
  cursor: pointer;
  width: 100%;
  transition: background 0.2s cubic-bezier(0.23, 1, 0.32, 1);
  padding: ${_ref9 => {
  let {
    theme
  } = _ref9;
  return theme.x1spacePx;
}}px
    ${_ref10 => {
  let {
    theme
  } = _ref10;
  return theme.x2spacePx;
}}px;
  ${_ref11 => {
  let {
    theme
  } = _ref11;
  return media.mdUp`
    &:hover {
      background: ${theme.color.brand01};
      color: ${theme.color.white};
      > svg {
        fill: ${theme.color.white};
      }
    }
  `;
}}

  > svg {
    opacity: 0.5;
    margin-left: -4px;
    height: 24px;
    width: 24px;
    padding-right: ${_ref12 => {
  let {
    theme
  } = _ref12;
  return theme.x4space;
}}px;
    fill: ${_ref13 => {
  let {
    theme
  } = _ref13;
  return theme.color.black;
}};
    transition: fill 0.2s cubic-bezier(0.23, 1, 0.32, 1);
  }
`;

const DropdownMenu = _ref => {
  let {
    options,
    dropUp,
    secondaryOptions,
    floatLeft,
    marginTop,
    marginLeft,
    marginRight,
    marginBottom
  } = _ref;
  return jsx(DropdownWrapper, {
    dropUp: dropUp,
    children: jsxs(Dropdown, {
      floatLeft: floatLeft,
      dropUp: dropUp,
      marginTop: marginTop,
      marginLeft: marginLeft,
      marginRight: marginRight,
      marginBottom: marginBottom,
      children: [options.map(DropDownButton => DropDownButton), secondaryOptions && secondaryOptions.length > 0 && jsx("hr", {}), secondaryOptions && secondaryOptions.length && secondaryOptions.map(DropDownButton => DropDownButton)]
    })
  });
};

const _excluded$8 = ["children", "options", "dropUp", "styleType", "secondaryOptions", "headerText", "floatLeft", "marginTop", "marginLeft", "marginRight", "marginBottom", "alignIcon", "onSelect", "onClick", "as"];
function isOptionItem(option) {
  return isValidElement(option);
}
const getDropDownButton = (onSelect, onTouchSelect, onBlur, onFocus, styleType, options) => {
  return options.map((option, i) => {
    if (isOptionItem(option)) {
      const childProps = {
        onTouchEnd: onTouchSelect,
        onBlur,
        onFocus,
        onSelect,
        styleType,
        key: `DropdownButton-${i}`
      };
      return cloneElement(option, childProps);
    } else {
      return jsxs(DropdownButton, {
        as: "a",
        tabIndex: -1,
        styleType: styleType,
        "data-cy-id": `dropdown-button-${i}`,
        onBlur: onBlur,
        onFocus: onFocus,
        onClick: () => {
          onSelect === null || onSelect === void 0 ? void 0 : onSelect(option.value, option.label);
        },
        onTouchEnd: e => {
          e.preventDefault();
          onTouchSelect(e.changedTouches[0].pageY, option.value, option.label);
        },
        children: [option.icon, option.label]
      }, `DropdownButton-${i}`);
    }
  });
};
const ButtonWithDropdown = _ref => {
  let {
      children,
      options,
      dropUp,
      styleType,
      secondaryOptions,
      headerText,
      floatLeft,
      marginTop,
      marginLeft,
      marginRight,
      marginBottom,
      alignIcon,
      onSelect,
      onClick
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded$8);
  const [isActive, setIsActive] = useState(false);
  const ref = useRef(null);
  const startYRef = useRef(0);
  let queue = 0;
  const handleTouchStart = useCallback(e => {
    const touch = e.changedTouches[0];
    startYRef.current = touch.pageY;
  }, []);
  const handleTouchEnd = useCallback(e => {
    const {
      current
    } = ref;
    const touch = e.changedTouches[0];
    if (isActive && current && Math.abs(touch.pageY - startYRef.current) < 1) {
      current.blur();
    }
  }, [isActive]);
  const handleKeyUp = e => {
    const {
      current
    } = ref;
    switch (e.keyCode) {
      case 27:
        if (current) {
          current.blur();
        }
        break;
    }
  };
  useEffect(() => {
    document.addEventListener('keyup', handleKeyUp);
    document.addEventListener('touchstart', handleTouchStart);
    document.addEventListener('touchend', handleTouchEnd);
    return () => {
      document.removeEventListener('keyup', handleKeyUp);
      document.removeEventListener('touchstart', handleTouchStart);
      document.removeEventListener('touchend', handleTouchEnd);
    };
  }, [handleTouchStart, handleTouchEnd]);
  const handleClick = e => {
    onClick && onClick();
    e.stopPropagation();
    e.preventDefault();
    const {
      current
    } = ref;
    if (current) {
      if (!isActive && document.activeElement !== current) {
        current.focus();
      }
    }
  };
  const handleSelect = (value, label) => {
    setIsActive(false);
    onSelect === null || onSelect === void 0 ? void 0 : onSelect(value, label);
  };
  const handleTouchSelect = (yPos, value, label) => {
    if (Math.abs(yPos - startYRef.current) < 1) {
      handleSelect(value, label);
    }
  };
  const handleFocus = () => {
    window.clearTimeout(queue);
    setIsActive(true);
  };
  const handleBlur = () => {
    // Using a queuing system for help tune for accessibility https://stackoverflow.com/a/38317768/2248347
    queue = window.setTimeout(() => {
      setIsActive(false);
    }, 0);
  };
  const shouldRenderDropdownMenu = isActive && (options.length > 0 || secondaryOptions && secondaryOptions.length > 0);
  return jsxs(ButtonWrapper, Object.assign({}, props, {
    children: [jsx(Button, {
      ref: ref,
      "data-active": isActive,
      styleType: styleType,
      onBlur: handleBlur,
      onFocus: handleFocus,
      onClick: handleClick,
      alignIcon: alignIcon,
      marginTop: marginTop,
      marginLeft: marginLeft,
      marginRight: marginRight,
      marginBottom: marginBottom,
      children: children
    }), shouldRenderDropdownMenu && jsx(DropdownMenu, {
      options: getDropDownButton(handleSelect, handleTouchSelect, handleBlur, handleFocus, styleType, options),
      secondaryOptions: secondaryOptions && getDropDownButton(handleSelect, handleTouchSelect, handleBlur, handleFocus, styleType, secondaryOptions),
      headerText: headerText,
      styleType: styleType,
      dropUp: dropUp,
      floatLeft: floatLeft,
      marginTop: marginTop,
      marginLeft: marginLeft,
      marginRight: marginRight,
      marginBottom: marginBottom,
      onBlur: handleBlur,
      onFocus: handleFocus,
      onSelect: handleSelect,
      onTouchSelect: handleTouchSelect
    })]
  }));
};

const disabled$1 = css`
  cursor: auto;
`;
const hover$1 = css`
  background: ${_ref => {
  let {
    theme,
    styleType
  } = _ref;
  if (styleType === 'subnav') return 'transparent;';
  return `${theme.color.whiteRGBA(0.1)};`;
}};
`;
const select = css`
  color: ${_ref2 => {
  let {
    theme
  } = _ref2;
  return theme.color.white;
}};
  ${_ref3 => {
  let {
    theme,
    styleType
  } = _ref3;
  if (styleType === 'period') {
    return css`
        background-color: ${theme.color.blackRGBA(0.3)};
      `;
  }
  if (styleType === 'subnav') {
    return css`
        box-shadow: 0px -${theme.x1spacePx / 2}px 0px 0px inset ${theme.color.brand01};
      `;
  }
  return css`
      border-color: ${theme.color.whiteRGBA(0.1)};
    `;
}}
`;
const padding = css`
  padding: ${_ref4 => {
  let {
    theme,
    styleType
  } = _ref4;
  if (styleType === 'period') {
    return `${theme.x1spacePx / 2}px ${theme.x1spacePx / 2}px;`;
  }
  if (styleType === 'subnav') {
    return `0px ${theme.x2spacePx}px ${theme.x1spacePx / 2}px;`;
  }
  return `${theme.x1spacePx}px ${theme.x2spacePx}px;`;
}};
`;
const border = css`
  ${_ref5 => {
  let {
    styleType
  } = _ref5;
  if (styleType === 'subnav') {
    return css`
        border: none;
      `;
  }
  return css`
      border-top: 1px solid transparent;
      border-left: 1px solid transparent;
      border-right: 1px solid transparent;
    `;
}};
`;
const height = css`
  height: ${_ref6 => {
  let {
    theme,
    styleType
  } = _ref6;
  if (styleType === 'subnav') {
    return `${theme.x6spacePx}px;`;
  }
  return 'auto;';
}};
`;
const typography = css`
  ${_ref7 => {
  let {
    theme,
    styleType
  } = _ref7;
  if (styleType === 'subnav') {
    return theme.typography.xSmall;
  }
  return theme.typography.xSmallStrong;
}}
`;
const tabCSS = css`
  position: relative;
  display: block;
  width: 100%;
  ${height}
  ${border}
  ${padding}
  ${typography}
  color: ${_ref8 => {
  let {
    styleType,
    theme
  } = _ref8;
  return theme.color.whiteRGBA(styleType === 'period' ? 0.3 : 0.5);
}};
  ${_ref9 => {
  let {
    selected
  } = _ref9;
  return selected && select;
}};
  ${_ref10 => {
  let {
    styleType,
    theme
  } = _ref10;
  return styleType === 'period' && `border-radius: ${theme.x1spacePx / 2}px;`;
}}
  &:disabled {
    ${disabled$1}
  }
  ${media.lgUp`
    &:hover:not(:disabled) {
      ${hover$1}
    }
  `}
`;
const StyledTab = styled('button')`
  ${tabCSS}
`;

const _excluded$7 = ["value", "selected", "disabled", "hasPanel", "styleType"];
const Tab = _ref => {
  let {
      value,
      selected,
      disabled,
      hasPanel = true,
      styleType = 'default'
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded$7);
  return jsx(StyledTab, Object.assign({
    role: "tab",
    value: value,
    id: `${value}-tab`,
    styleType: styleType,
    selected: selected,
    "aria-selected": Boolean(selected),
    "aria-controls": hasPanel ? `${value}-panel` : undefined,
    disabled: disabled !== null && disabled !== void 0 ? disabled : selected
  }, props));
};

const getValue = value => typeof value === 'string' ? value : `${value}px`;
const getPadding = px => css`
  padding: ${_ref => {
  let {
    theme
  } = _ref;
  return theme[px];
}}px;
`;
const getPaddingX = px => css`
  padding-left: ${_ref2 => {
  let {
    theme
  } = _ref2;
  return theme[px];
}}px;
  padding-right: ${_ref3 => {
  let {
    theme
  } = _ref3;
  return theme[px];
}}px;
`;
const getPaddingY = px => css`
  padding-top: ${_ref4 => {
  let {
    theme
  } = _ref4;
  return theme[px];
}}px;
  padding-bottom: ${_ref5 => {
  let {
    theme
  } = _ref5;
  return theme[px];
}}px;
`;
const getPaddingTop = px => css`
  padding-top: ${_ref6 => {
  let {
    theme
  } = _ref6;
  return theme[px];
}}px;
`;
const getPaddingRight = px => css`
  padding-right: ${_ref7 => {
  let {
    theme
  } = _ref7;
  return theme[px];
}}px;
`;
const getPaddingBottom = px => css`
  padding-bottom: ${_ref8 => {
  let {
    theme
  } = _ref8;
  return theme[px];
}}px;
`;
const getPaddingLeft = px => css`
  padding-left: ${_ref9 => {
  let {
    theme
  } = _ref9;
  return theme[px];
}}px;
`;
const getMargin = px => css`
  margin: ${_ref10 => {
  let {
    theme
  } = _ref10;
  return theme[px];
}}px;
`;
const getMarginX = px => css`
  margin-left: ${_ref11 => {
  let {
    theme
  } = _ref11;
  return theme[px];
}}px;
  margin-right: ${_ref12 => {
  let {
    theme
  } = _ref12;
  return theme[px];
}}px;
`;
const getMarginY = px => css`
  margin-top: ${_ref13 => {
  let {
    theme
  } = _ref13;
  return theme[px];
}}px;
  margin-bottom: ${_ref14 => {
  let {
    theme
  } = _ref14;
  return theme[px];
}}px;
`;
const getMarginTop = px => css`
  margin-top: ${_ref15 => {
  let {
    theme
  } = _ref15;
  return theme[px];
}}px;
`;
const getMarginRight = px => css`
  margin-right: ${_ref16 => {
  let {
    theme
  } = _ref16;
  return theme[px];
}}px;
`;
const getMarginBottom = px => css`
  margin-bottom: ${_ref17 => {
  let {
    theme
  } = _ref17;
  return theme[px];
}}px;
`;
const getMarginLeft = px => css`
  margin-left: ${_ref18 => {
  let {
    theme
  } = _ref18;
  return theme[px];
}}px;
`;
const getBorderRadius = px => css`
  border-radius: ${_ref19 => {
  let {
    theme
  } = _ref19;
  return theme[px];
}}px;
`;
const getBorderTopRightRadius = px => css`
  border-top-right-radius: ${_ref20 => {
  let {
    theme
  } = _ref20;
  return theme[px];
}}px;
`;
const getBorderTopLeftRadius = px => css`
  border-top-left-radius: ${_ref21 => {
  let {
    theme
  } = _ref21;
  return theme[px];
}}px;
`;
const getBorderBottomRightRadius = px => css`
  border-bottom-right-radius: ${_ref22 => {
  let {
    theme
  } = _ref22;
  return theme[px];
}}px;
`;
const getBorderBottomLeftRadius = px => css`
  border-bottom-left-radius: ${_ref23 => {
  let {
    theme
  } = _ref23;
  return theme[px];
}}px;
`;
const getDisplay$1 = display => css`
  display: ${display};
`;
const getPosition = position => css`
  position: ${position};
`;
const getTop = top => css`
  top: ${getValue(top)};
`;
const getRight = right => css`
  right: ${getValue(right)};
`;
const getBottom = bottom => css`
  bottom: ${getValue(bottom)};
`;
const getLeft = left => css`
  left: ${getValue(left)};
`;
const getWidth = width => css`
  width: ${getValue(width)};
`;
const getMaxWidth = maxWidth => css`
  max-width: ${getValue(maxWidth)};
`;
const getMinWidth = minWidth => css`
  min-width: ${getValue(minWidth)};
`;
const getHeight = height => css`
  height: ${getValue(height)};
`;
const getMaxHeight = maxHeight => css`
  max-height: ${getValue(maxHeight)};
`;
const getMinHeight = minHeight => css`
  min-height: ${getValue(minHeight)};
`;
const getCursor = cursor => css`
  cursor: ${cursor};
`;
const getZIndex = zIndex => css`
  z-index: ${zIndex};
`;
const getUserSelect = userSelect => css`
  user-select: ${userSelect};
`;
const getOverflow = overflow => css`
  overflow: ${overflow};
`;
const getTransform = transform => css`
  transform: ${transform};
`;
const getOpacity = opacity => css`
  opacity: ${opacity};
`;
const getBackground = backgroundColor => {
  if (backgroundColor === 'transparent' || backgroundColor === 'inherit') {
    return css`
      background-color: ${backgroundColor};
    `;
  }
  return css`
    background-color: ${_ref24 => {
    let {
      theme
    } = _ref24;
    return theme.color[backgroundColor];
  }};
  `;
};
const StyledBoxCSS = css`
  ${_ref25 => {
  let {
    $display
  } = _ref25;
  return $display && getDisplay$1($display);
}}
  ${_ref26 => {
  let {
    position
  } = _ref26;
  return position && getPosition(position);
}}
  ${_ref27 => {
  let {
    top
  } = _ref27;
  return top && getTop(top);
}}
  ${_ref28 => {
  let {
    right
  } = _ref28;
  return right && getRight(right);
}}
  ${_ref29 => {
  let {
    bottom
  } = _ref29;
  return bottom && getBottom(bottom);
}}
  ${_ref30 => {
  let {
    left
  } = _ref30;
  return left && getLeft(left);
}}
  ${_ref31 => {
  let {
    width
  } = _ref31;
  return width && getWidth(width);
}}
  ${_ref32 => {
  let {
    maxWidth
  } = _ref32;
  return maxWidth && getMaxWidth(maxWidth);
}}
  ${_ref33 => {
  let {
    minWidth
  } = _ref33;
  return minWidth && getMinWidth(minWidth);
}}
  ${_ref34 => {
  let {
    height
  } = _ref34;
  return height && getHeight(height);
}}
  ${_ref35 => {
  let {
    maxHeight
  } = _ref35;
  return maxHeight && getMaxHeight(maxHeight);
}}
  ${_ref36 => {
  let {
    minHeight
  } = _ref36;
  return minHeight && getMinHeight(minHeight);
}}
  ${_ref37 => {
  let {
    cursor
  } = _ref37;
  return cursor && getCursor(cursor);
}}
  ${_ref38 => {
  let {
    zIndex
  } = _ref38;
  return zIndex && getZIndex(zIndex);
}}
  ${_ref39 => {
  let {
    userSelect
  } = _ref39;
  return userSelect && getUserSelect(userSelect);
}}
  ${_ref40 => {
  let {
    overflow
  } = _ref40;
  return overflow && getOverflow(overflow);
}}
  ${_ref41 => {
  let {
    transform
  } = _ref41;
  return transform && getTransform(transform);
}}
  ${_ref42 => {
  let {
    opacity
  } = _ref42;
  return opacity && getOpacity(opacity);
}}
  ${_ref43 => {
  let {
    backgroundColor
  } = _ref43;
  return backgroundColor && getBackground(backgroundColor);
}}

  ${_ref44 => {
  let {
    padding
  } = _ref44;
  return padding && getPadding(padding);
}};
  ${_ref45 => {
  let {
    paddingX
  } = _ref45;
  return paddingX && getPaddingX(paddingX);
}};
  ${_ref46 => {
  let {
    paddingY
  } = _ref46;
  return paddingY && getPaddingY(paddingY);
}};
  ${_ref47 => {
  let {
    paddingTop
  } = _ref47;
  return paddingTop && getPaddingTop(paddingTop);
}};
  ${_ref48 => {
  let {
    paddingRight
  } = _ref48;
  return paddingRight && getPaddingRight(paddingRight);
}};
  ${_ref49 => {
  let {
    paddingBottom
  } = _ref49;
  return paddingBottom && getPaddingBottom(paddingBottom);
}};
  ${_ref50 => {
  let {
    paddingLeft
  } = _ref50;
  return paddingLeft && getPaddingLeft(paddingLeft);
}};

  ${_ref51 => {
  let {
    margin
  } = _ref51;
  return margin && getMargin(margin);
}};
  ${_ref52 => {
  let {
    marginX
  } = _ref52;
  return marginX && getMarginX(marginX);
}};
  ${_ref53 => {
  let {
    marginY
  } = _ref53;
  return marginY && getMarginY(marginY);
}};
  ${_ref54 => {
  let {
    marginTop
  } = _ref54;
  return marginTop && getMarginTop(marginTop);
}};
  ${_ref55 => {
  let {
    marginRight
  } = _ref55;
  return marginRight && getMarginRight(marginRight);
}};
  ${_ref56 => {
  let {
    marginBottom
  } = _ref56;
  return marginBottom && getMarginBottom(marginBottom);
}};
  ${_ref57 => {
  let {
    marginLeft
  } = _ref57;
  return marginLeft && getMarginLeft(marginLeft);
}};

  ${_ref58 => {
  let {
    borderRadius
  } = _ref58;
  return borderRadius && getBorderRadius(borderRadius);
}};
  ${_ref59 => {
  let {
    borderTopRightRadius
  } = _ref59;
  return borderTopRightRadius && getBorderTopRightRadius(borderTopRightRadius);
}};
  ${_ref60 => {
  let {
    borderTopLeftRadius
  } = _ref60;
  return borderTopLeftRadius && getBorderTopLeftRadius(borderTopLeftRadius);
}};
  ${_ref61 => {
  let {
    borderBottomRightRadius
  } = _ref61;
  return borderBottomRightRadius && getBorderBottomRightRadius(borderBottomRightRadius);
}};
  ${_ref62 => {
  let {
    borderBottomLeftRadius
  } = _ref62;
  return borderBottomLeftRadius && getBorderBottomLeftRadius(borderBottomLeftRadius);
}};

  /*
    media.smUp
  */
  ${_ref63 => {
  let {
    // Padding
    paddingSm,
    paddingXSm,
    paddingYSm,
    paddingTopSm,
    paddingRightSm,
    paddingBottomSm,
    paddingLeftSm,
    // Margin
    marginSm,
    marginXSm,
    marginYSm,
    marginTopSm,
    marginRightSm,
    marginBottomSm,
    marginLeftSm,
    // BorderRadius
    borderRadiusSm,
    borderTopLeftRadiusSm,
    borderTopRightRadiusSm,
    borderBottomLeftRadiusSm,
    borderBottomRightRadiusSm
  } = _ref63;
  if (
  // Padding
  paddingSm || paddingXSm || paddingYSm || paddingTopSm || paddingRightSm || paddingBottomSm || paddingLeftSm ||
  // Margin
  marginSm || marginXSm || marginYSm || marginTopSm || marginRightSm || marginBottomSm || marginLeftSm ||
  // BorderRadius
  borderRadiusSm || borderTopLeftRadiusSm || borderTopRightRadiusSm || borderBottomLeftRadiusSm || borderBottomRightRadiusSm) {
    return media.smUp`
        ${paddingSm && getPadding(paddingSm)};
        ${paddingXSm && getPaddingX(paddingXSm)};
        ${paddingYSm && getPaddingY(paddingYSm)};
        ${paddingTopSm && getPaddingTop(paddingTopSm)};
        ${paddingRightSm && getPaddingRight(paddingRightSm)};
        ${paddingBottomSm && getPaddingBottom(paddingBottomSm)};
        ${paddingLeftSm && getPaddingLeft(paddingLeftSm)};

        ${marginSm && getMargin(marginSm)};
        ${marginXSm && getMarginX(marginXSm)};
        ${marginYSm && getMarginY(marginYSm)};
        ${marginTopSm && getMarginTop(marginTopSm)};
        ${marginRightSm && getMarginRight(marginRightSm)};
        ${marginBottomSm && getMarginBottom(marginBottomSm)};
        ${marginLeftSm && getMarginLeft(marginLeftSm)};

        ${borderRadiusSm && getBorderRadius(borderRadiusSm)};
        ${borderTopRightRadiusSm && getBorderTopRightRadius(borderTopRightRadiusSm)};
        ${borderTopLeftRadiusSm && getBorderTopLeftRadius(borderTopLeftRadiusSm)};
        ${borderBottomRightRadiusSm && getBorderBottomRightRadius(borderBottomRightRadiusSm)};
        ${borderBottomLeftRadiusSm && getBorderBottomLeftRadius(borderBottomLeftRadiusSm)};
      `;
  }
}}
  /*
    media.mdUp
  */
  ${_ref64 => {
  let {
    // Padding
    paddingMd,
    paddingXMd,
    paddingYMd,
    paddingTopMd,
    paddingRightMd,
    paddingBottomMd,
    paddingLeftMd,
    // Margin
    marginMd,
    marginXMd,
    marginYMd,
    marginTopMd,
    marginRightMd,
    marginBottomMd,
    marginLeftMd,
    // BorderRadius
    borderRadiusMd,
    borderTopLeftRadiusMd,
    borderTopRightRadiusMd,
    borderBottomLeftRadiusMd,
    borderBottomRightRadiusMd
  } = _ref64;
  if (
  // Padding
  paddingMd || paddingXMd || paddingYMd || paddingTopMd || paddingRightMd || paddingBottomMd || paddingLeftMd ||
  // Margin
  marginMd || marginXMd || marginYMd || marginTopMd || marginRightMd || marginBottomMd || marginLeftMd ||
  // BorderRadius
  borderRadiusMd || borderTopLeftRadiusMd || borderTopRightRadiusMd || borderBottomLeftRadiusMd || borderBottomRightRadiusMd) {
    return media.mdUp`
        ${paddingMd && getPadding(paddingMd)};
        ${paddingXMd && getPaddingX(paddingXMd)};
        ${paddingYMd && getPaddingY(paddingYMd)};
        ${paddingTopMd && getPaddingTop(paddingTopMd)};
        ${paddingRightMd && getPaddingRight(paddingRightMd)};
        ${paddingBottomMd && getPaddingBottom(paddingBottomMd)};
        ${paddingLeftMd && getPaddingLeft(paddingLeftMd)};
        
        ${marginMd && getMargin(marginMd)}; 
        ${marginXMd && getMarginX(marginXMd)};
        ${marginYMd && getMarginY(marginYMd)};
        ${marginTopMd && getMarginTop(marginTopMd)};
        ${marginRightMd && getMarginRight(marginRightMd)};
        ${marginBottomMd && getMarginBottom(marginBottomMd)};
        ${marginLeftMd && getMarginLeft(marginLeftMd)};

        ${borderRadiusMd && getBorderRadius(borderRadiusMd)};
        ${borderTopRightRadiusMd && getBorderTopRightRadius(borderTopRightRadiusMd)};
        ${borderTopLeftRadiusMd && getBorderTopLeftRadius(borderTopLeftRadiusMd)};
        ${borderBottomRightRadiusMd && getBorderBottomRightRadius(borderBottomRightRadiusMd)};
        ${borderBottomLeftRadiusMd && getBorderBottomLeftRadius(borderBottomLeftRadiusMd)};
      `;
  }
}}
  /*
    media.lgUp
  */
  ${_ref65 => {
  let {
    // Padding
    paddingLg,
    paddingXLg,
    paddingYLg,
    paddingTopLg,
    paddingRightLg,
    paddingBottomLg,
    paddingLeftLg,
    // Margin
    marginLg,
    marginXLg,
    marginYLg,
    marginTopLg,
    marginRightLg,
    marginBottomLg,
    marginLeftLg,
    // BorderRadius
    borderRadiusLg,
    borderTopLeftRadiusLg,
    borderTopRightRadiusLg,
    borderBottomLeftRadiusLg,
    borderBottomRightRadiusLg
  } = _ref65;
  if (
  // Padding
  paddingLg || paddingXLg || paddingYLg || paddingTopLg || paddingRightLg || paddingBottomLg || paddingLeftLg ||
  // Margin
  marginLg || marginXLg || marginYLg || marginTopLg || marginRightLg || marginBottomLg || marginLeftLg ||
  // BorderRadius
  borderRadiusLg || borderTopLeftRadiusLg || borderTopRightRadiusLg || borderBottomLeftRadiusLg || borderBottomRightRadiusLg) {
    return media.lgUp`
        ${paddingLg && getPadding(paddingLg)};
        ${paddingXLg && getPaddingX(paddingXLg)};
        ${paddingYLg && getPaddingY(paddingYLg)};
        ${paddingTopLg && getPaddingTop(paddingTopLg)};
        ${paddingRightLg && getPaddingRight(paddingRightLg)};
        ${paddingBottomLg && getPaddingBottom(paddingBottomLg)};
        ${paddingLeftLg && getPaddingLeft(paddingLeftLg)};

        ${marginLg && getMargin(marginLg)};
        ${marginXLg && getMarginX(marginXLg)};
        ${marginYLg && getMarginY(marginYLg)};
        ${marginTopLg && getMarginTop(marginTopLg)};
        ${marginRightLg && getMarginRight(marginRightLg)};
        ${marginBottomLg && getMarginBottom(marginBottomLg)};
        ${marginLeftLg && getMarginLeft(marginLeftLg)};

        ${borderRadiusLg && getBorderRadius(borderRadiusLg)};
        ${borderTopRightRadiusLg && getBorderTopRightRadius(borderTopRightRadiusLg)};
        ${borderTopLeftRadiusLg && getBorderTopLeftRadius(borderTopLeftRadiusLg)};
        ${borderBottomRightRadiusLg && getBorderBottomRightRadius(borderBottomRightRadiusLg)};
        ${borderBottomLeftRadiusLg && getBorderBottomLeftRadius(borderBottomLeftRadiusLg)};
      `;
  }
}}
  /*
    media.xlUp
  */
  ${_ref66 => {
  let {
    // Padding
    paddingXl,
    paddingXXl,
    paddingYXl,
    paddingTopXl,
    paddingRightXl,
    paddingBottomXl,
    paddingLeftXl,
    // Margin
    marginXl,
    marginXXl,
    marginYXl,
    marginTopXl,
    marginRightXl,
    marginBottomXl,
    marginLeftXl,
    // BorderRadius
    borderRadiusXl,
    borderTopLeftRadiusXl,
    borderTopRightRadiusXl,
    borderBottomLeftRadiusXl,
    borderBottomRightRadiusXl
  } = _ref66;
  if (
  // Padding
  paddingXl || paddingXXl || paddingYXl || paddingTopXl || paddingRightXl || paddingBottomXl || paddingLeftXl ||
  // Margin
  marginXl || marginXXl || marginYXl || marginTopXl || marginRightXl || marginBottomXl || marginLeftXl ||
  // BorderRadius
  borderRadiusXl || borderTopLeftRadiusXl || borderTopRightRadiusXl || borderBottomLeftRadiusXl || borderBottomRightRadiusXl) {
    return media.xlUp`
        ${paddingXl && getPadding(paddingXl)};
        ${paddingXXl && getPaddingX(paddingXXl)};
        ${paddingYXl && getPaddingY(paddingYXl)};
        ${paddingTopXl && getPaddingTop(paddingTopXl)};
        ${paddingRightXl && getPaddingRight(paddingRightXl)};
        ${paddingBottomXl && getPaddingBottom(paddingBottomXl)};
        ${paddingLeftXl && getPaddingLeft(paddingLeftXl)};

        ${marginXl && getMargin(marginXl)};
        ${marginXXl && getMarginX(marginXXl)};
        ${marginYXl && getMarginY(marginYXl)};
        ${marginTopXl && getMarginTop(marginTopXl)};
        ${marginRightXl && getMarginRight(marginRightXl)};
        ${marginBottomXl && getMarginBottom(marginBottomXl)};
        ${marginLeftXl && getMarginLeft(marginLeftXl)};

        ${borderRadiusXl && getBorderRadius(borderRadiusXl)};
        ${borderTopRightRadiusXl && getBorderTopRightRadius(borderTopRightRadiusXl)};
        ${borderTopLeftRadiusXl && getBorderTopLeftRadius(borderTopLeftRadiusXl)};
        ${borderBottomRightRadiusXl && getBorderBottomRightRadius(borderBottomRightRadiusXl)};
        ${borderBottomLeftRadiusXl && getBorderBottomLeftRadius(borderBottomLeftRadiusXl)};
      `;
  }
}}
`;
const StyledBox = styled('div')`
  ${StyledBoxCSS}
`;

const getDisplay = display => css`
  display: ${display};
`;
const getGap = gap => css`
  grid-gap: ${gap};
`;
const getRowGap = gap => css`
  grid-row-gap: ${gap};
`;
const getColumnGap = gap => css`
  grid-column-gap: ${gap};
`;
const getTemplate = template => css`
  grid-template: ${template};
`;
const getTemplateColumns = cols => css`
  grid-template-columns: ${cols};
`;
const getTemplateRows = rows => css`
  grid-template-rows: ${rows};
`;
const getRow = row => css`
  grid-row: ${row};
`;
const getColumn = column => css`
  grid-column: ${column};
`;
const getAutoFlow = flow => css`
  grid-auto-flow: ${flow};
`;
const getAutoRows = rows => css`
  grid-auto-rows: ${rows};
`;
const getAutoColumns = columns => css`
  grid-auto-columns: ${columns};
`;
const getJustifyItems = alignment => css`
  justify-items: ${alignment};
`;
const getJustifyContent = alignment => css`
  justify-content: ${alignment};
`;
const getAlignItems = alignment => css`
  align-items: ${alignment};
`;
const getAlignContent = alignment => css`
  align-content: ${alignment};
`;
const getPlaceItems = alignment => css`
  place-items: ${alignment};
`;
const getPlaceContent = alignment => css`
  place-content: ${alignment};
`;
const Grid = styled('div')`
  ${StyledBoxCSS}
  /* Display */
  ${_ref => {
  let {
    display = 'grid'
  } = _ref;
  return display && getDisplay(display);
}}
  /* Gaps */
  ${_ref2 => {
  let {
    gap
  } = _ref2;
  return gap && getGap(gap);
}}
  ${_ref3 => {
  let {
    rowGap
  } = _ref3;
  return rowGap && getRowGap(rowGap);
}}
  ${_ref4 => {
  let {
    columnGap
  } = _ref4;
  return columnGap && getColumnGap(columnGap);
}}
  /* Template */
  ${_ref5 => {
  let {
    template
  } = _ref5;
  return template && getTemplate(template);
}}
  ${_ref6 => {
  let {
    templateColumns
  } = _ref6;
  return templateColumns && getTemplateColumns(templateColumns);
}}
  ${_ref7 => {
  let {
    templateRows
  } = _ref7;
  return templateRows && getTemplateRows(templateRows);
}}
  /* Alignment */
  ${_ref8 => {
  let {
    justifyItems
  } = _ref8;
  return justifyItems && getJustifyItems(justifyItems);
}}
  ${_ref9 => {
  let {
    justifyContent
  } = _ref9;
  return justifyContent && getJustifyContent(justifyContent);
}}
  ${_ref10 => {
  let {
    alignItems
  } = _ref10;
  return alignItems && getAlignItems(alignItems);
}}
  ${_ref11 => {
  let {
    alignContent
  } = _ref11;
  return alignContent && getAlignContent(alignContent);
}}
  ${_ref12 => {
  let {
    placeItems
  } = _ref12;
  return placeItems && getPlaceItems(placeItems);
}}
  ${_ref13 => {
  let {
    placeContent
  } = _ref13;
  return placeContent && getPlaceContent(placeContent);
}}
  /* Child Properties */
  ${_ref14 => {
  let {
    row
  } = _ref14;
  return row && getRow(row);
}}
  ${_ref15 => {
  let {
    column
  } = _ref15;
  return column && getColumn(column);
}}
  /* Auto Properties */
  ${_ref16 => {
  let {
    autoFlow
  } = _ref16;
  return autoFlow && getAutoFlow(autoFlow);
}}
  ${_ref17 => {
  let {
    autoRows
  } = _ref17;
  return autoRows && getAutoRows(autoRows);
}}
  ${_ref18 => {
  let {
    autoColumns
  } = _ref18;
  return autoColumns && getAutoColumns(autoColumns);
}}
  /*
    media.smUp
  */
  ${_ref19 => {
  let {
    displaySm,
    gapSm,
    rowGapSm,
    columnGapSm,
    templateSm,
    templateColumnsSm,
    templateRowsSm,
    justifyItemsSm,
    justifyContentSm,
    alignItemsSm,
    alignContentSm,
    placeItemsSm,
    placeContentSm,
    rowSm,
    columnSm,
    autoFlowSm,
    autoRowsSm,
    autoColumnsSm
  } = _ref19;
  if (displaySm || gapSm || rowGapSm || columnGapSm || templateSm || templateColumnsSm || templateRowsSm || justifyItemsSm || justifyContentSm || alignItemsSm || alignContentSm || placeItemsSm || placeContentSm || rowSm || columnSm || autoFlowSm || autoRowsSm || autoColumnsSm) {
    return media.smUp`
        /* Display */
        ${displaySm && getDisplay(displaySm)};
        /* Gaps */
        ${gapSm && getGap(gapSm)}
        ${rowGapSm && getRowGap(rowGapSm)}
        ${columnGapSm && getColumnGap(columnGapSm)}
        /* Template */
        ${templateSm && getTemplate(templateSm)}
        ${templateColumnsSm && getTemplateColumns(templateColumnsSm)}
        ${templateRowsSm && getTemplateRows(templateRowsSm)}
        /* Alignment */
        ${justifyItemsSm && getJustifyItems(justifyItemsSm)}
        ${justifyContentSm && getJustifyContent(justifyContentSm)}
        ${alignItemsSm && getAlignItems(alignItemsSm)}
        ${alignContentSm && getAlignContent(alignContentSm)}
        ${placeItemsSm && getPlaceItems(placeItemsSm)}
        ${placeContentSm && getPlaceContent(placeContentSm)}
        /* Child Properties */
        ${rowSm && getRow(rowSm)}
        ${columnSm && getColumn(columnSm)}
        /* Auto Properties */
        ${autoFlowSm && getAutoFlow(autoFlowSm)}
        ${autoRowsSm && getAutoRows(autoRowsSm)}
        ${autoColumnsSm && getAutoColumns(autoColumnsSm)}
      `;
  }
}}
  /*
    media.mdUp
  */
  ${_ref20 => {
  let {
    displayMd,
    gapMd,
    rowGapMd,
    columnGapMd,
    templateMd,
    templateColumnsMd,
    templateRowsMd,
    justifyItemsMd,
    justifyContentMd,
    alignItemsMd,
    alignContentMd,
    placeItemsMd,
    placeContentMd,
    rowMd,
    columnMd,
    autoFlowMd,
    autoRowsMd,
    autoColumnsMd
  } = _ref20;
  if (displayMd || gapMd || rowGapMd || columnGapMd || templateMd || templateColumnsMd || templateRowsMd || justifyItemsMd || justifyContentMd || alignItemsMd || alignContentMd || placeItemsMd || placeContentMd || rowMd || columnMd || autoFlowMd || autoRowsMd || autoColumnsMd) {
    return media.mdUp`
        /* Display */
        ${displayMd && getDisplay(displayMd)};
        /* Gaps */
        ${gapMd && getGap(gapMd)}
        ${rowGapMd && getRowGap(rowGapMd)}
        ${columnGapMd && getColumnGap(columnGapMd)}
        /* Template */
        ${templateMd && getTemplate(templateMd)}
        ${templateColumnsMd && getTemplateColumns(templateColumnsMd)}
        ${templateRowsMd && getTemplateRows(templateRowsMd)}
        /* Alignment */
        ${justifyItemsMd && getJustifyItems(justifyItemsMd)}
        ${justifyContentMd && getJustifyContent(justifyContentMd)}
        ${alignItemsMd && getAlignItems(alignItemsMd)}
        ${alignContentMd && getAlignContent(alignContentMd)}
        ${placeItemsMd && getPlaceItems(placeItemsMd)}
        ${placeContentMd && getPlaceContent(placeContentMd)}
        /* Child Properties */
        ${rowMd && getRow(rowMd)}
        ${columnMd && getColumn(columnMd)}
        /* Auto Properties */
        ${autoFlowMd && getAutoFlow(autoFlowMd)}
        ${autoRowsMd && getAutoRows(autoRowsMd)}
        ${autoColumnsMd && getAutoColumns(autoColumnsMd)}
      `;
  }
}}
  /*
    media.lgUp
  */
  ${_ref21 => {
  let {
    displayLg,
    gapLg,
    rowGapLg,
    columnGapLg,
    templateLg,
    templateColumnsLg,
    templateRowsLg,
    justifyItemsLg,
    justifyContentLg,
    alignItemsLg,
    alignContentLg,
    placeItemsLg,
    placeContentLg,
    rowLg,
    columnLg,
    autoFlowLg,
    autoRowsLg,
    autoColumnsLg
  } = _ref21;
  if (displayLg || gapLg || rowGapLg || columnGapLg || templateLg || templateColumnsLg || templateRowsLg || justifyItemsLg || justifyContentLg || alignItemsLg || alignContentLg || placeItemsLg || placeContentLg || rowLg || columnLg || autoFlowLg || autoRowsLg || autoColumnsLg) {
    return media.lgUp`
        /* Display */
        ${displayLg && getDisplay(displayLg)};
        /* Gaps */
        ${gapLg && getGap(gapLg)}
        ${rowGapLg && getRowGap(rowGapLg)}
        ${columnGapLg && getColumnGap(columnGapLg)}
        /* Template */
        ${templateLg && getTemplate(templateLg)}
        ${templateColumnsLg && getTemplateColumns(templateColumnsLg)}
        ${templateRowsLg && getTemplateRows(templateRowsLg)}
        /* Alignment */
        ${justifyItemsLg && getJustifyItems(justifyItemsLg)}
        ${justifyContentLg && getJustifyContent(justifyContentLg)}
        ${alignItemsLg && getAlignItems(alignItemsLg)}
        ${alignContentLg && getAlignContent(alignContentLg)}
        ${placeItemsLg && getPlaceItems(placeItemsLg)}
        ${placeContentLg && getPlaceContent(placeContentLg)}
        /* Child Properties */
        ${rowLg && getRow(rowLg)}
        ${columnLg && getColumn(columnLg)}
        /* Auto Properties */
        ${autoFlowLg && getAutoFlow(autoFlowLg)}
        ${autoRowsLg && getAutoRows(autoRowsLg)}
        ${autoColumnsLg && getAutoColumns(autoColumnsLg)}
      `;
  }
}}
  /*
    media.xlUp
  */
  ${_ref22 => {
  let {
    displayXl,
    gapXl,
    rowGapXl,
    columnGapXl,
    templateXl,
    templateColumnsXl,
    templateRowsXl,
    justifyItemsXl,
    justifyContentXl,
    alignItemsXl,
    alignContentXl,
    placeItemsXl,
    placeContentXl,
    rowXl,
    columnXl,
    autoFlowXl,
    autoRowsXl,
    autoColumnsXl
  } = _ref22;
  if (displayXl || gapXl || rowGapXl || columnGapXl || templateXl || templateColumnsXl || templateRowsXl || justifyItemsXl || justifyContentXl || alignItemsXl || alignContentXl || placeItemsXl || placeContentXl || rowXl || columnXl || autoFlowXl || autoRowsXl || autoColumnsXl) {
    return media.xlUp`
        /* Display */
        ${displayXl && getDisplay(displayXl)};
        /* Gaps */
        ${gapXl && getGap(gapXl)}
        ${rowGapXl && getRowGap(rowGapXl)}
        ${columnGapXl && getColumnGap(columnGapXl)}
        /* Template */
        ${templateXl && getTemplate(templateXl)}
        ${templateColumnsXl && getTemplateColumns(templateColumnsXl)}
        ${templateRowsXl && getTemplateRows(templateRowsXl)}
        /* Alignment */
        ${justifyItemsXl && getJustifyItems(justifyItemsXl)}
        ${justifyContentXl && getJustifyContent(justifyContentXl)}
        ${alignItemsXl && getAlignItems(alignItemsXl)}
        ${alignContentXl && getAlignContent(alignContentXl)}
        ${placeItemsXl && getPlaceItems(placeItemsXl)}
        ${placeContentXl && getPlaceContent(placeContentXl)}
        /* Child Properties */
        ${rowXl && getRow(rowXl)}
        ${columnXl && getColumn(columnXl)}
        /* Auto Properties */
        ${autoFlowXl && getAutoFlow(autoFlowXl)}
        ${autoRowsXl && getAutoRows(autoRowsXl)}
        ${autoColumnsXl && getAutoColumns(autoColumnsXl)}
      `;
  }
}}
`;

const TabList = props => jsx(Grid, Object.assign({
  role: "tablist"
}, props));

const _excluded$6 = ["value", "selected"];
const TabPanel = _ref => {
  let {
      value,
      selected
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded$6);
  if (selected) {
    return jsx(Grid, Object.assign({
      role: "tabpanel",
      id: `${value}-panel`,
      "aria-labelledby": `${value}-tab`
    }, props));
  }
  return null;
};

const svg = css`
  ${_ref => {
  let {
    theme,
    alignIcon
  } = _ref;
  const dimensions = theme.x3spacePx;
  return css`
      > svg {
        display: inline;
        fill: ${theme.color.white};
        opacity: 0.5;
        width: ${dimensions}px;
        height: ${dimensions}px;
        vertical-align: middle;
        ${alignIcon && css`
          padding-${alignIcon}: 4px;
        `}
      }
    `;
}}
`;
const disabled = css`
  cursor: auto;
  pointer-events: none;
  opacity: 0.3;
  color: ${_ref2 => {
  let {
    theme,
    styleType
  } = _ref2;
  switch (styleType) {
    case 'strong':
      return theme.color.whiteRGBA(0.7);
    default:
      return theme.color.white;
  }
}};
  background-color: ${_ref3 => {
  let {
    theme,
    styleType
  } = _ref3;
  switch (styleType) {
    case 'strong':
      return theme.color.brand01RGBA(0.3);
    default:
      return 'transparent';
  }
}};
`;
const hover = css`
  background-color: ${_ref4 => {
  let {
    theme,
    styleType,
    state
  } = _ref4;
  switch (styleType) {
    case 'subtle':
      return theme.color.whiteRGBA(0.1);
    case 'strong':
      return state === 'off' ? theme.color.whiteRGBA(0.1) : theme.color.brand01;
  }
}};
`;
const backgroundColor = css`
  background-color: ${_ref5 => {
  let {
    theme,
    styleType,
    state
  } = _ref5;
  if (state === 'off') {
    return 'transparent';
  }
  switch (styleType) {
    case 'subtle':
      return theme.color.whiteRGBA(0.2);
    case 'strong':
      return theme.color.brand01;
  }
}};
`;
const toggleButtonCss = css`
  ${_ref6 => {
  let {
    theme
  } = _ref6;
  return theme.typography.tiny;
}}
  &:disabled {
    ${disabled}
  }
  &:hover,
  &:visited {
    ${hover}
  }
  position: relative;
  display: inline-flex;
  align-items: center;
  height: ${_ref7 => {
  let {
    theme
  } = _ref7;
  return theme.x4spacePx - 4;
}}px;
  line-height: ${_ref8 => {
  let {
    theme
  } = _ref8;
  return theme.x4spacePx - 4;
}}px;
  color: ${_ref9 => {
  let {
    theme
  } = _ref9;
  return theme.color.white;
}};
  vertical-align: middle;
  border-radius: ${_ref10 => {
  let {
    theme
  } = _ref10;
  return theme.x1spacePx / 2;
}}px;
  padding: ${_ref11 => {
  let {
    theme
  } = _ref11;
  return `0 ${theme.x2spacePx - 4}px`;
}};
  ${backgroundColor}
  ${svg}
`;
const ToggleButton = styled('button').attrs(_ref12 => {
  let {
    theme
  } = _ref12;
  return Object.assign({}, theme.focus('dashed'));
})`
  ${toggleButtonCss}
`;

const _excluded$5 = ["as", "children"];
const Box = forwardRef((_ref, ref) => {
  let {
      as = 'div',
      children
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded$5);
  return jsx(StyledBox, Object.assign({
    ref: ref,
    as: as
  }, props, {
    children: children
  }));
});
Box.displayName = 'Box';

const colorFor = {
  p: 'white',
  b: 'white',
  i: 'white',
  strong: 'white',
  em: 'white',
  h1: 'white',
  h2: 'white',
  h3: 'white',
  h4: 'white',
  h5: 'white',
  h6: 'white',
  span: 'inherit'
};
const typographyFor = {
  p: 'base',
  b: 'base',
  i: 'base',
  strong: 'base',
  em: 'base',
  h1: 'mega',
  h2: 'xLarge',
  h3: 'large',
  h4: 'large',
  h5: 'base',
  h6: 'base',
  span: 'inherit'
};

const StyledText = styled('span')`
  margin: 0;
  ${_ref => {
  let {
    theme,
    typography
  } = _ref;
  return theme.typography[typography];
}}
  color: ${_ref2 => {
  let {
    theme,
    $color,
    $opacity
  } = _ref2;
  if ($color === 'inherit') {
    return 'inherit';
  }
  return applyColor(theme.color[$color], $opacity);
}};
  ${_ref3 => {
  let {
    textAlign
  } = _ref3;
  return textAlign && css`
      text-align: ${textAlign};
    `;
}}
  ${_ref4 => {
  let {
    textTransform
  } = _ref4;
  return textTransform && css`
      text-transform: ${textTransform};
    `;
}}
  ${_ref5 => {
  let {
    isTruncated
  } = _ref5;
  return isTruncated && Ellipsis;
}}
  ${_ref6 => {
  let {
    lineClamp
  } = _ref6;
  return typeof lineClamp !== 'undefined' && EllipsisWithLineClamp(lineClamp);
}}
`;

const _excluded$4 = ["as", "opacity", "textAlign", "textTransform", "color", "typography", "isTruncated", "lineClamp", "children"];
const Text = _ref => {
  let {
      as = 'p',
      opacity,
      textAlign,
      textTransform,
      color = colorFor[as],
      typography = typographyFor[as],
      isTruncated = false,
      lineClamp,
      children
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded$4);
  return jsx(StyledText, Object.assign({
    as: as,
    "$color": color,
    "$opacity": opacity,
    textAlign: textAlign,
    textTransform: textTransform,
    typography: typography,
    isTruncated: isTruncated,
    lineClamp: lineClamp
  }, props, {
    children: children
  }));
};

const _excluded$3 = ["as", "opacity", "textAlign", "textTransform", "color", "typography", "isTruncated", "lineClamp", "children"];
const Heading = _ref => {
  let {
      as,
      opacity,
      textAlign,
      textTransform,
      color = colorFor[as],
      typography = typographyFor[as],
      isTruncated = false,
      lineClamp,
      children
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded$3);
  return jsx(StyledText, Object.assign({
    as: as,
    "$color": color,
    "$opacity": opacity,
    textAlign: textAlign,
    typography: typography,
    textTransform: textTransform,
    isTruncated: isTruncated,
    lineClamp: lineClamp
  }, props, {
    children: children
  }));
};

const easeOutCubic = 'cubic-bezier(0.23, 1, 0.32, 1)';
const exit = () => keyframes`
  from        { opacity: 1; }
  to          { opacity: 0; }
`;
const StyledAlert = styled(Grid)`
  width: 100%;
  border: 1px solid ${_ref => {
  let {
    theme
  } = _ref;
  return theme.color.whiteRGBA(0.05);
}};
  box-shadow: 0 ${_ref2 => {
  let {
    theme
  } = _ref2;
  return theme.x1spacePx;
}}px
    ${_ref3 => {
  let {
    theme
  } = _ref3;
  return theme.x2spacePx / 2;
}}px
    ${_ref4 => {
  let {
    theme
  } = _ref4;
  return theme.color.blackRGBA(0.25);
}};
  background-color: ${_ref5 => {
  let {
    theme
  } = _ref5;
  return theme.color.phantom;
}};
  border-radius: ${_ref6 => {
  let {
    theme
  } = _ref6;
  return theme.x1spacePx;
}}px;
  padding: ${_ref7 => {
  let {
    theme
  } = _ref7;
  return theme.x3spacePx / 2;
}}px;

  ${_ref8 => {
  let {
    state
  } = _ref8;
  if (state === 'exiting') {
    return css`
        animation: ${exit} 0.2s ${easeOutCubic} 0s forwards;
      `;
  }
}}
`;
const IconWrapper = styled('div')`
  align-self: start;
  transform: translateY(1px);
  svg {
    width: 24px;
    height: 24px;
  }
`;
const AlertIconLoadingWrapper = styled('div')`
  position: relative;
  align-self: start;
  transform: translateY(3px);
  padding-left: ${_ref9 => {
  let {
    theme
  } = _ref9;
  return theme.x1spacePx / 2;
}}px;
`;

const STYLE_TYPES = {
  positive: {
    Icon: SuccessSolid,
    color: 'good'
  },
  warning: {
    Icon: WarningSolid,
    color: 'warning'
  },
  negative: {
    Icon: DangerSolid,
    color: 'bad'
  }
};
function isColor(color, theme) {
  return color in theme.color && typeof theme.color[color] === 'string';
}
const AlertIcon = _ref => {
  let {
    styleType
  } = _ref;
  const theme = useTheme();
  if (styleType === 'loading') {
    return jsx(AlertIconLoadingWrapper, {
      children: jsx(LoadingSpinner, {
        styleType: "light",
        role: "presentation"
      })
    });
  }
  const {
    Icon,
    color
  } = STYLE_TYPES[styleType];
  return jsx(IconWrapper, {
    children: jsx(Icon, {
      fill: isColor(color, theme) ? theme.color[color] : theme.color.white,
      role: "presentation"
    })
  });
};

const AlertActions = _ref => {
  let {
    children,
    layout
  } = _ref;
  return jsx(Grid, {
    templateColumns: `repeat(${Children.count(children)}, max-content)`,
    gap: "12px",
    column: layout === 'stack' ? 'span 2' : '',
    justifyContent: layout === 'stack' ? 'end' : 'start',
    children: children
  });
};

const defaultState = {
  current: 'default',
  isDismissed: false,
  onDismiss() {
    return;
  }
};
const alertStateContext = createContext(undefined);
function useAlertStateContext() {
  const context = useContext(alertStateContext);
  if (typeof context === 'undefined') {
    console.warn('useAlertStateContext: Attempting to access undefined context, possibly outside of `AlertStateProvider`. Default context will be returned, but it does not respond to updates.');
    return defaultState;
  }
  return context;
}
const AlertStateProvider = _ref => {
  let {
    children,
    value
  } = _ref;
  if (value.isDismissed) {
    return null;
  }
  return jsx(alertStateContext.Provider, {
    value: value,
    children: children
  });
};

const variants = {
  link: {
    base: css`
      color: ${_ref => {
      let {
        theme
      } = _ref;
      return theme.color.brand01;
    }};
    `,
    hover: css`
      background-color: ${_ref2 => {
      let {
        theme
      } = _ref2;
      return theme.color.brand01RGBA(0.1);
    }};
    `,
    active: css`
      background-color: ${_ref3 => {
      let {
        theme
      } = _ref3;
      return theme.color.blackRGBA(0.1);
    }};
    `,
    disabled: css`
      color: ${_ref4 => {
      let {
        theme
      } = _ref4;
      return theme.color.brand01RGBA(0.1);
    }};
    `
  }
};
const StyledAlertAction = styled('button').attrs(_ref5 => {
  let {
    theme
  } = _ref5;
  return theme.focus('dashed');
})`
  ${_ref6 => {
  let {
    theme
  } = _ref6;
  return theme.typography.xSmall;
}}
  transition: 0.2s background-color, 0.2s box-shadow, 0.4s color;

  border: 0;
  margin: 0;
  border-radius: 6px;
  white-space: nowrap;
  text-decoration: none;
  /** required so focus outline works */
  position: relative;

  /** size specific - 'small' */
  min-height: 28px;
  padding-left: ${_ref7 => {
  let {
    theme
  } = _ref7;
  return theme.x1spacePx;
}}px;
  padding-right: ${_ref8 => {
  let {
    theme
  } = _ref8;
  return theme.x1spacePx;
}}px;

  /** variant */
  ${_ref9 => {
  let {
    variant = 'link'
  } = _ref9;
  return variants[variant].base;
}}

  ${_ref10 => {
  let {
    variant = 'link'
  } = _ref10;
  return media.mdUp`
    &:hover {
      ${variants[variant].hover}
    }
  `;
}}
  
  &:active {
    ${_ref11 => {
  let {
    variant = 'link'
  } = _ref11;
  return variants[variant].active;
}}
  }

  &:disabled {
    cursor: auto;
    pointer-events: none;
    ${_ref12 => {
  let {
    variant = 'link'
  } = _ref12;
  return variants[variant].disabled;
}}
  }
`;

const _excluded$2 = ["children", "onClick", "shouldDismissAlert"];
const AlertAction = _ref => {
  let {
      children,
      onClick,
      shouldDismissAlert = true
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded$2);
  const {
    onDismiss
  } = useAlertStateContext();
  const handleClick = e => {
    onClick === null || onClick === void 0 ? void 0 : onClick(e);
    if (shouldDismissAlert) {
      onDismiss();
    }
  };
  return jsx(StyledAlertAction, Object.assign({
    onClick: handleClick
  }, props, {
    children: children
  }));
};

const _excluded$1 = ["title", "styleType", "children", "actions", "onDismiss", "layout", "icon"];
const isPrimitive = p => ['string', 'number', 'boolean'].includes(typeof p);
const isPrimitiveChildren = c => isPrimitive(c) || Array.isArray(c) && c.every(isPrimitive);
const Alert = _ref => {
  let {
      title,
      styleType,
      children,
      actions,
      onDismiss,
      layout = 'inline',
      icon = null
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded$1);
  const [state, setState] = useState('default');
  const context = useMemo(() => ({
    current: state,
    isDismissed: state === 'dismissed',
    onDismiss() {
      setState('exiting');
    }
  }), [state]);
  const handleAnimationEnd = useCallback(() => {
    onDismiss === null || onDismiss === void 0 ? void 0 : onDismiss();
    setState('dismissed');
  }, [onDismiss]);
  const iconElement = useMemo(() => {
    if (icon) {
      return jsx(IconWrapper, {
        children: icon
      });
    }
    if (styleType) {
      return jsx(AlertIcon, {
        styleType: styleType
      });
    }
    return null;
  }, [icon, styleType]);
  return jsx(AlertStateProvider, {
    value: context,
    children: jsxs(StyledAlert, Object.assign({
      as: "section",
      role: "alert",
      columnGap: "12px",
      rowGap: layout === 'stack' ? '16px' : undefined,
      alignItems: "center",
      state: state,
      onAnimationEnd: handleAnimationEnd,
      templateColumns: [iconElement ? '24px' : '', 'auto', actions ? 'minmax(min-content, max-content)' : ''].join(' ')
    }, props, {
      children: [iconElement, jsxs("div", {
        children: [title ? jsx(Heading, {
          as: "h2",
          typography: "baseStrong",
          children: title
        }) : null, isPrimitiveChildren(children) ? jsx(Text, {
          typography: "small",
          children: children
        }) : children]
      }), actions ? jsx(AlertActions, {
        layout: layout,
        children: actions
      }) : null]
    }))
  });
};

const _excluded = ["as", "backgroundColor", "borderRadius", "minHeight", "display"];
const Bones = _ref => {
  let {
      as = 'span',
      backgroundColor = 'white',
      borderRadius = 'x0_25',
      minHeight,
      display = 'block'
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  return jsx(StyledBox, Object.assign({
    as: as,
    "$display": display,
    minHeight: minHeight || theme.x2,
    backgroundColor: backgroundColor,
    borderRadius: borderRadius,
    opacity: 0.1
  }, props));
};

var _path$1, _path2$1, _path3$1, _path4$1, _path5$1, _path6$1, _path7$1, _path8$1, _path9$1, _path10$1, _path11$1, _path12$1, _path13$1, _path14$1, _path15$1, _path16$1, _path17$1, _path18$1, _path19$1, _path20$1, _path21$1, _path22$1, _path23$1, _path24$1, _path25$1, _path26$1, _path27$1, _path28$1, _path29;
function _extends$1() { _extends$1 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1.apply(this, arguments); }
function SvgSwsLogo(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends$1({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 180 42",
    ref: svgRef
  }, props), _path$1 || (_path$1 = /*#__PURE__*/React.createElement("path", {
    d: "M61.362 32.3h-9.72V19.19h2.909v10.488h6.81V32.3zM41.538 25.802v-4.008h2.248c1.454 0 2.361.693 2.361 1.985v.037c0 1.124-.85 1.986-2.304 1.986h-2.305zm-2.91 6.498h2.91v-3.933h2.21c2.966 0 5.347-1.574 5.347-4.607v-.037c0-2.678-1.91-4.532-5.063-4.532h-5.404V32.3zm-16.398 0h2.852v-8.502l3.684 5.543h.076l3.722-5.6V32.3h2.89V19.19h-3.08l-3.532 5.544-3.62-5.543H22.23V32.3zM67.374 32.3h-2.91v-5.169l-5.082-7.94h3.401l3.155 5.262 3.211-5.262h3.308l-5.083 7.884V32.3zM18.922 32.3h-2.909V19.19h2.91V32.3zM13.209 28.423c0 2.604-2.204 4.064-5.343 4.064-2.204 0-4.428-.693-6.173-2.098l1.688-2.03c1.31.975 2.886 1.582 4.548 1.582 1.31 0 2.224-.47 2.224-1.236v-.037c0-.731-.552-1.149-2.983-1.711-2.932-.674-4.896-1.592-4.896-3.965v-.036c0-2.38 2.12-3.952 5.093-3.952 2.12 0 3.93.598 5.405 1.666l-1.732 2.14c-1.289-.806-2.488-1.26-3.715-1.26-1.225 0-2.047.505-2.047 1.142v.038c0 .861.8 1.143 3.316 1.723 2.953.693 4.615 1.649 4.615 3.933v.037zM129.322 27.521l3.022-6.62 3.005 6.62h-6.027zm-3.682 4.78h1.528l1.568-3.44h7.2l1.548 3.44h1.607l-6.028-13.11h-1.398L125.64 32.3zM150.297 32.3h-8.794V19.19h1.493v11.744h7.301V32.3zM161.59 32.3h-8.795V19.19h1.493v11.744h7.302V32.3zM114.143 32.3h-1.337l-4.148-13.11h1.454l3.387 10.841 3.248-10.84h1.101l3.25 10.84 3.384-10.84h1.406l-4.161 13.11h-1.294l-3.159-10.523-3.131 10.522zM164.148 30.934h14.86v1.367h-14.86v-1.367zM171.409 26.049c0 1.795-1.461 2.854-3.458 2.854-1.509 0-2.816-.477-3.929-1.446l1.205-1.408c.834.672 1.666 1.106 2.724 1.106.834 0 1.376-.384 1.376-.914v-.025c0-.541-.336-.953-1.863-1.306-1.867-.466-3.07-1.188-3.07-2.866v-.025c0-1.64 1.349-2.725 3.241-2.725 1.349 0 2.499.413 3.438 1.15l-1.056 1.497c-.821-.555-1.629-.89-2.409-.89-.781 0-1.191.348-1.191.787v.026c0 .594.396.89 1.998 1.29 1.878.477 2.994 1.294 2.994 2.869v.026zM176.606 28.819h-1.942v-7.562h-2.481v-1.834h6.89v1.835h-2.467v7.56z",
    fill: "#fff"
  })), _path2$1 || (_path2$1 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.596 9.015c9.016 0 16.325 7.244 16.325 16.182 0 8.937-7.309 16.183-16.325 16.183-9.016 0-16.326-7.246-16.326-16.183S81.58 9.015 90.596 9.015z",
    fill: "#CCC"
  })), _path3$1 || (_path3$1 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M106.506 28.832h.002l-.003.01a16.088 16.088 0 01-.629 2.066l-.036.093c-.034.083-.066.167-.101.25a1.83 1.83 0 01-.055.131c-.028.073-.059.145-.089.218l-.072.162-.085.184-.085.184-.079.164a16.343 16.343 0 01-14.677 9.087 16.338 16.338 0 01-14.686-9.106l-.059-.12c-.036-.08-.075-.157-.11-.237-.02-.041-.038-.082-.057-.124l-.107-.241-.048-.112a15.444 15.444 0 01-.106-.259l-.04-.1a22.707 22.707 0 01-.108-.278l-.031-.083-.106-.297-.023-.069c-.035-.104-.07-.21-.103-.316l-.018-.057a13.32 13.32 0 01-.1-.332l-.011-.045a30.529 30.529 0 01-.096-.343l-.01-.04a16.49 16.49 0 01-.085-.35l-.01-.038v-.003a587.29 587.29 0 018.538-5.6c2.718-.646 5.175-1.007 7.376-1.083 2.198.077 4.656.437 7.374 1.082 3.144 2.017 6.52 4.204 8.553 5.529v.001l-.002.002v.001c-.005.024-.009.046-.016.07z",
    fill: "#1A1A1A"
  })), _path4$1 || (_path4$1 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.684 28.832a587.29 587.29 0 018.537-5.6c2.718-.646 5.175-1.007 7.376-1.083 2.198.077 4.656.437 7.374 1.082 3.144 2.017 6.52 4.204 8.553 5.528-.022.103-.047.204-.072.306l-.012.05c-.024.096-.05.19-.076.287l-.016.06a7.339 7.339 0 01-.081.286l-.013.043c-.158.531-.343 1.051-.552 1.558l-.019.04c-.036.09-.076.179-.114.269l-.026.059-.119.262-.025.054c-.043.088-.084.179-.128.268l-.011.02c-.193.387-.398.766-.622 1.137l-.027.047c-.048.079-.098.157-.146.234l-.043.07c-.048.076-.097.15-.146.225l-.047.07c-.048.076-.1.15-.151.224l-.038.056c-.237.337-.484.665-.745.984-.016.02-.035.042-.05.063-.053.065-.108.129-.161.19a2.645 2.645 0 01-.073.086l-.157.18-.079.087c-.053.06-.108.119-.161.177-.025.028-.05.055-.079.083-.056.059-.111.119-.17.177a14.257 14.257 0 01-.749.726l-.159.143-.113.1c-.05.044-.103.088-.156.133-.042.033-.082.068-.122.102l-.158.129c-.039.033-.081.065-.123.099l-.16.126c-.042.032-.085.066-.13.099-.055.04-.105.08-.159.12l-.134.096a17.875 17.875 0 01-.444.312c-.05.032-.098.065-.146.097l-.16.104c-.052.033-.102.064-.15.096l-.162.1-.151.09-.172.101-.146.084a10.38 10.38 0 01-.184.101 10.095 10.095 0 01-.384.205l-.107.055-.298.147c-.04.02-.08.038-.121.057l-.216.099-.138.062c-.069.03-.136.06-.204.088l-.146.061-.203.082-.144.057-.216.081-.135.05-.274.096a4.201 4.201 0 00-.078.027c-.118.038-.237.078-.357.114l-.096.028a10.704 10.704 0 01-.395.114c-.08.021-.159.044-.24.064l-.14.035c-.077.02-.156.038-.233.057l-.142.032-.243.053c-.043.01-.086.018-.13.027a11.28 11.28 0 01-.375.07c-.127.024-.256.045-.383.064l-.043.006c-.113.017-.227.033-.341.048l-.115.014-.271.03-.134.014c-.087.008-.173.016-.26.022-.046.004-.092.008-.14.01a7.07 7.07 0 01-.259.017l-.136.008c-.096.005-.193.008-.29.01l-.102.004a17.748 17.748 0 01-.8 0l-.104-.003-.29-.01-.132-.01a7.468 7.468 0 01-.4-.026c-.088-.006-.173-.014-.259-.022-.045-.004-.09-.007-.133-.013-.094-.01-.189-.02-.28-.032a15.488 15.488 0 01-.48-.064l-.01-.002a12.467 12.467 0 01-.469-.078c-.098-.018-.197-.035-.294-.056l-.122-.025a15.032 15.032 0 01-.628-.144c-.043-.012-.087-.022-.13-.033a11.358 11.358 0 01-.367-.1c-.107-.03-.213-.06-.32-.093l-.042-.013c-.122-.038-.243-.078-.364-.117-.026-.009-.051-.019-.078-.027-.093-.032-.184-.063-.275-.096l-.12-.044-.233-.088a8.583 8.583 0 01-.129-.05l-.222-.09-.126-.053a28.61 28.61 0 01-.344-.15 11.509 11.509 0 01-.275-.126l-.06-.028a17.402 17.402 0 01-.411-.204c-.085-.044-.17-.09-.253-.132-.038-.02-.075-.041-.113-.063l-.213-.117-.12-.068-.203-.12-.119-.07-.209-.13c-.034-.02-.068-.043-.103-.066-.08-.05-.159-.103-.238-.154l-.072-.048-.304-.208-.06-.043c-.079-.057-.159-.114-.238-.173-.034-.025-.068-.05-.102-.077-.064-.047-.128-.095-.19-.144l-.111-.087a5.557 5.557 0 01-.182-.145c-.036-.03-.073-.058-.107-.088-.06-.049-.121-.099-.18-.15-.035-.03-.07-.058-.104-.089a9.734 9.734 0 01-.19-.166c-.028-.026-.058-.05-.086-.077-.09-.08-.178-.162-.266-.246l-.05-.047c-.072-.067-.142-.136-.212-.205l-.095-.096a15.519 15.519 0 01-.517-.542l-.146-.164a12.065 12.065 0 01-.097-.111c-.053-.06-.104-.12-.155-.182a15.546 15.546 0 01-.31-.377c-.01-.012-.02-.027-.032-.04a22.838 22.838 0 01-.19-.246c-.029-.038-.055-.076-.085-.113l-.131-.18a8.246 8.246 0 01-.211-.3l-.089-.13-.12-.181c-.03-.042-.055-.084-.083-.127-.04-.063-.08-.126-.118-.19-.026-.04-.053-.081-.078-.122-.048-.08-.096-.16-.142-.24-.023-.038-.046-.076-.067-.114a9.364 9.364 0 01-.223-.4c-.034-.064-.07-.128-.103-.193l-.073-.143c-.032-.062-.063-.125-.094-.189-.023-.048-.048-.097-.07-.146-.03-.061-.059-.123-.088-.186l-.07-.152a4.88 4.88 0 01-.085-.193l-.063-.143-.096-.234-.045-.11c-.044-.11-.086-.22-.128-.332l-.052-.145c-.025-.067-.05-.136-.073-.204l-.052-.158a8.696 8.696 0 01-.065-.197l-.05-.162-.06-.197-.047-.162c-.02-.068-.036-.136-.055-.204-.015-.053-.03-.105-.042-.158-.02-.076-.038-.152-.056-.227l-.034-.138v-.007h-.002z",
    fill: "#333"
  })), _path5$1 || (_path5$1 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.684 28.832c3.554 2.673 7.802 4.97 7.802 4.97-.835 1.163-1.514 2.545-2.046 4.066a16.17 16.17 0 01-5.756-9.036z",
    fill: "#333"
  })), _path6$1 || (_path6$1 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M106.524 28.759c-3.557 2.672-7.804 4.97-7.804 4.97.845 1.175 1.528 2.574 2.062 4.112a16.134 16.134 0 005.742-9.082zM75.529 31.438l-.846-2.606 8.657-5.601 7.263 15.239v2.91h-.006a16.332 16.332 0 01-15.068-9.942z",
    fill: "#4D4D4D"
  })), _path7$1 || (_path7$1 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M105.739 31.253l.719-2.22c.018-.07.037-.14.05-.21l-8.641-5.593-7.264 15.24v2.91c6.853-.003 12.718-4.191 15.136-10.127z",
    fill: "#333"
  })), _path8$1 || (_path8$1 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M83.22 23.23l7.376 15.69 7.374-15.69H83.22z",
    fill: "#CCC"
  })), _path9$1 || (_path9$1 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M88.667 34.818l1.93 4.102 1.927-4.102-1.396-2.598h-.03l1.057-1.003.162-.137-.575-2.917c-.102-.102-.083-.114-.207-.114l-.94.19-.94-.19c-.125 0-.106.012-.207.114l-.575 2.917.16.137 1.059 1.003h-.03l-1.395 2.598z",
    fill: "#C30"
  })), _path10$1 || (_path10$1 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.597 38.92l1.927-4.102-1.396-2.598h-.03l1.057-1.003.162-.137-.575-2.917c-.102-.102-.083-.114-.207-.114l-.94.19v10.68h.002z",
    fill: "#A32900"
  })), _path11$1 || (_path11$1 = /*#__PURE__*/React.createElement("path", {
    d: "M91.5 34.495h-3.541v.707h3.54v-.707z",
    fill: "#FC0"
  })), _path12$1 || (_path12$1 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M83.22 23.23l4.313 9.176 3.063-3.028 2.93-6.148h4.444l-4.311 9.176-3.063-3.028-2.933-6.148H83.22z",
    fill: "#fff"
  })), _path13$1 || (_path13$1 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M81.696 24.215l-.359 4.013 2.446 1.086-1.817 1.092 8.63 8.514-7.376-15.69-1.524.985zM99.494 24.215l.36 4.013-2.446 1.086 1.818 1.092-8.63 8.514 7.374-15.69 1.524.985z",
    fill: "#1A1A1A"
  })), _path14$1 || (_path14$1 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.603 39.623c.369 0 .666.297.666.661 0 .364-.297.66-.666.66a.663.663 0 01-.665-.66c0-.365.298-.66.665-.66z",
    fill: "#B3B3B3"
  })), _path15$1 || (_path15$1 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.603 39.623c.369 0 .666.297.666.661 0 .364-.297.66-.666.66v-1.32z",
    fill: "gray"
  })), _path16$1 || (_path16$1 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.603 39.623c.369 0 .666.297.666.661 0 .364-.297.66-.666.66a.663.663 0 01-.665-.66c0-.365.298-.66.665-.66z",
    fill: "#B3B3B3"
  })), _path17$1 || (_path17$1 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.603 39.623c.369 0 .666.297.666.661 0 .364-.297.66-.666.66v-1.32z",
    fill: "gray"
  })), _path18$1 || (_path18$1 = /*#__PURE__*/React.createElement("path", {
    d: "M101.327 35.52h-5.61v.775h5.61v-.775z",
    fill: "#4D4D4D"
  })), _path19$1 || (_path19$1 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M95.718 35.52l2.288-2.269 1.299 1.285.515-.51 1.507 1.494h-5.609z",
    fill: "#fff"
  })), _path20$1 || (_path20$1 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M98.62 14.082c-.808-1.038-.78-1.932.083-2.684 3.463.945 5.241 1.384 5.329 1.317-1.368 2.09-3.173 2.546-5.412 1.367zm-16.05 0c.809-1.038.781-1.932-.083-2.684-3.463.945-5.238 1.384-5.328 1.317 1.367 2.09 3.172 2.546 5.412 1.367z",
    fill: "#963"
  })), _path21$1 || (_path21$1 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M95.683 12.667c-1.698-1.98-1.944-3.106-.74-3.377 4.785.25 6.611-1.826 5.48-6.223L99.557.999c2.953 1.921 4.273 4.554 3.87 7.893-.228 1.89-2.837 3.146-7.744 3.775zm-10.175 0c1.698-1.98 1.944-3.106.74-3.377-4.785.25-6.61-1.826-5.48-6.223.577-1.38.868-2.068.868-2.068-2.955 1.921-4.274 4.554-3.872 7.893.227 1.89 2.836 3.146 7.744 3.775z",
    fill: "#4D4D4D"
  })), _path22$1 || (_path22$1 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.596 29.378l-10.761-8.97c.186-4.75 1.104-8.7 2.756-11.849 1.605-1.86 4.263-2.39 8.005-2.39 3.74 0 6.398.53 8.002 2.39 1.652 3.15 2.571 7.1 2.758 11.85l-10.76 8.969z",
    fill: "#C93"
  })), _path23$1 || (_path23$1 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.597 6.169c3.74 0 6.398.53 8.002 2.39 1.651 3.15 2.57 7.1 2.757 11.85l-10.76 8.969V6.168z",
    fill: "#A37A29"
  })), _path24$1 || (_path24$1 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.892 19.088c.294-4.166 1.188-7.676 2.684-10.53.064-.073.129-.146.197-.215 4.13-3.252 3.276 7.405 3.319 8.746.433 1.542-.58 2.484-3.038 2.828-1.275-.19-2.329-.467-3.162-.829zM101.3 19.088c-.294-4.166-1.19-7.676-2.685-10.53a5.314 5.314 0 00-.197-.215c-4.131-3.252-3.277 7.405-3.319 8.746-.433 1.542.58 2.484 3.039 2.828 1.274-.19 2.327-.467 3.162-.829z",
    fill: "#963"
  })), _path25$1 || (_path25$1 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.596 29.378L79.835 20.41a39.41 39.41 0 01.265-3.32h20.989c.132 1.06.221 2.166.267 3.32l-10.76 8.97z",
    fill: "#963"
  })), _path26$1 || (_path26$1 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.597 29.378l-7.069-5.889s.929-1.391 2.783-4.176c-.107-.977-.119-1.718-.038-2.223h1.8c.662.697 1.503 1.842 2.523 3.438 1.018-1.596 1.857-2.74 2.52-3.438h1.801c.08.506.068 1.247-.038 2.223 1.854 2.785 2.783 4.176 2.783 4.176l-7.065 5.89z",
    fill: "#85592B"
  })), _path27$1 || (_path27$1 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86.312 19.313c.056-1.424 2.296-.082 3.329.614.167.128.338.248.511.36h.001c.154.1.311.193.469.28.363-.199.718-.434 1.063-.704 1.07-.71 3.18-1.931 3.234-.55 3.05-5.389-11.809-5.377-8.607 0z",
    fill: "#1A1A1A"
  })), _path28$1 || (_path28$1 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.597 15.56c1.37 0 2.482.54 2.482 1.205s-1.111 1.204-2.482 1.204c-1.373 0-2.485-.54-2.485-1.204 0-.666 1.112-1.205 2.485-1.205z",
    fill: "#666"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.597 23.19c-3.486 0-4.114-.62-3.94-1.968.046 1.129 1.358 1.391 3.94 1.391 2.58 0 3.891-.262 3.937-1.391.174 1.349-.454 1.968-3.938 1.968zM96.513 12.928c-.644-.027-1.21.491-1.419 1.156-.518-4.31 3.511-4.49 4.413-1.662-.76.46-1.577.567-2.994.506zm-11.835 0c.645-.027 1.21.491 1.42 1.156.517-4.31-3.513-4.49-4.413-1.662.759.46 1.576.567 2.993.506z",
    fill: "#1A1A1A"
  })));
}
const ForwardRef$1 = /*#__PURE__*/React.forwardRef(SvgSwsLogo);

var SWSLogoIcon = forwardRef((props, ref) => jsx(ForwardRef$1, Object.assign({
  ref: ref
}, props)));

var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function SvgSwsLogoSm(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 40",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 7.94c8.837 0 16 7.177 16 16.03 0 8.852-7.163 16.029-16 16.029-8.836 0-16-7.177-16-16.03C0 15.117 7.164 7.94 16 7.94z",
    fill: "#CCC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.593 27.57h.002l-.003.01a15.96 15.96 0 01-.617 2.046l-.035.093c-.033.082-.065.165-.1.246a1.62 1.62 0 01-.052.131c-.028.072-.058.143-.088.215-.022.054-.048.108-.07.161l-.084.182a7.928 7.928 0 01-.084.183c-.024.054-.051.108-.077.162-2.6 5.329-8.064 9-14.384 9-6.328 0-11.797-3.679-14.393-9.018l-.057-.12c-.036-.078-.074-.155-.109-.235l-.056-.122-.104-.24-.047-.11c-.036-.085-.07-.17-.105-.256l-.038-.1a20.561 20.561 0 01-.106-.275l-.03-.082c-.036-.098-.07-.197-.104-.295l-.023-.067c-.034-.103-.069-.209-.1-.313l-.019-.057c-.034-.11-.066-.22-.097-.329l-.012-.044a31.106 31.106 0 01-.093-.34l-.01-.04a16.62 16.62 0 01-.084-.346l-.009-.038v-.003a574.915 574.915 0 018.367-5.548c2.664-.639 5.073-.996 7.23-1.071 2.153.076 4.562.432 7.226 1.071 3.082 1.998 6.39 4.165 8.383 5.476v.002l-.002.002-.016.07z",
    fill: "#1A1A1A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M.405 27.57a574.09 574.09 0 018.367-5.548c2.664-.64 5.073-.997 7.23-1.072 2.153.076 4.562.433 7.226 1.072 3.082 1.997 6.39 4.164 8.383 5.476-.022.101-.047.201-.071.302l-.011.049-.075.285-.016.059a6.41 6.41 0 01-.08.284l-.012.043a16.27 16.27 0 01-.541 1.542l-.019.04c-.035.089-.074.177-.111.266l-.026.059-.117.26-.024.053c-.043.088-.082.177-.125.265l-.011.02c-.19.384-.39.76-.61 1.126l-.026.047-.143.232-.043.07c-.047.074-.094.148-.143.222l-.046.07a6.379 6.379 0 01-.148.221l-.037.056c-.232.333-.474.659-.73.975l-.05.062c-.051.064-.105.127-.157.189a2.327 2.327 0 01-.071.084l-.154.179-.078.086-.157.175c-.025.028-.05.055-.078.082-.054.059-.11.118-.166.176l-.06.062a14.327 14.327 0 01-.674.657l-.156.141-.111.099-.153.132c-.041.033-.08.068-.12.102l-.154.127-.12.098c-.054.042-.104.083-.158.124-.041.033-.083.066-.127.099l-.156.118-.131.096a20.915 20.915 0 01-.435.309c-.05.032-.096.064-.143.096-.053.034-.104.07-.158.103l-.147.095-.158.098-.148.091-.169.1-.143.083-.18.1a10.263 10.263 0 01-.376.203l-.105.054c-.098.05-.195.098-.293.145-.039.02-.078.038-.118.057-.07.034-.141.066-.211.098l-.136.062a17.247 17.247 0 01-.343.147l-.198.082-.142.056-.211.08-.133.05-.269.095-.076.026c-.115.038-.232.078-.35.114-.03.01-.062.018-.094.028a10.85 10.85 0 01-.387.112l-.235.064c-.045.01-.092.023-.138.034-.075.02-.152.038-.228.056l-.139.032a15.16 15.16 0 01-1.485.266l-.112.013-.266.031-.131.013a14.65 14.65 0 01-.646.049l-.134.008-.283.01a16.501 16.501 0 01-.986 0l-.285-.01-.13-.008a7.17 7.17 0 01-.392-.027c-.086-.006-.169-.014-.253-.022-.044-.004-.088-.007-.13-.012-.092-.01-.185-.02-.275-.032a14.408 14.408 0 01-.47-.064l-.01-.001a12.628 12.628 0 01-.46-.079c-.096-.017-.192-.034-.288-.054l-.12-.025a14.472 14.472 0 01-.615-.143l-.127-.032a11.183 11.183 0 01-.36-.1c-.105-.03-.208-.06-.313-.092l-.042-.013c-.12-.037-.238-.077-.357-.116l-.076-.026-.27-.095c-.04-.014-.078-.03-.117-.043l-.229-.088a8.275 8.275 0 01-.126-.05l-.217-.089-.124-.052a27.618 27.618 0 01-.337-.148c-.09-.04-.18-.083-.27-.126-.019-.01-.039-.018-.06-.027a17.054 17.054 0 01-.401-.203l-.248-.13c-.038-.02-.074-.041-.111-.062l-.209-.116-.116-.068-.2-.118-.116-.07-.205-.128-.102-.066c-.078-.05-.155-.102-.233-.153l-.07-.047c-.1-.068-.2-.137-.299-.207l-.058-.042a16.923 16.923 0 01-.233-.171l-.1-.076c-.063-.048-.126-.095-.187-.143l-.109-.086a5.729 5.729 0 01-.178-.144l-.105-.087c-.059-.049-.118-.098-.177-.149l-.101-.088a9.854 9.854 0 01-.186-.164c-.028-.026-.057-.05-.084-.076a11.64 11.64 0 01-.31-.291c-.07-.066-.14-.135-.208-.203l-.093-.094a15.868 15.868 0 01-.506-.538l-.144-.163a14.074 14.074 0 01-.095-.11c-.052-.059-.101-.119-.152-.18a15.78 15.78 0 01-.304-.373l-.03-.04c-.063-.08-.125-.161-.187-.243-.028-.038-.054-.076-.083-.112a29.436 29.436 0 01-.218-.305 7.832 7.832 0 01-.118-.171c-.03-.043-.059-.085-.087-.13-.04-.058-.078-.119-.118-.178-.028-.041-.054-.083-.08-.125a27.448 27.448 0 01-.117-.188c-.025-.04-.052-.081-.076-.122l-.14-.237-.065-.113a9.379 9.379 0 01-.218-.396c-.034-.064-.068-.127-.101-.192l-.072-.141-.092-.187-.07-.145-.085-.184-.068-.151a4.855 4.855 0 01-.083-.191l-.062-.142-.095-.231-.044-.108c-.043-.11-.084-.22-.125-.33l-.051-.144a20.71 20.71 0 01-.072-.202l-.05-.156a8.513 8.513 0 01-.064-.195l-.05-.16-.058-.197-.046-.16c-.02-.067-.036-.134-.054-.201-.015-.053-.029-.105-.04-.157-.02-.076-.038-.15-.056-.225l-.033-.136v-.007H.405z",
    fill: "#333"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M.405 27.57c3.483 2.647 7.647 4.924 7.647 4.924-.819 1.151-1.484 2.52-2.005 4.026a16.037 16.037 0 01-5.642-8.95z",
    fill: "#333"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.61 27.497c-3.485 2.647-7.648 4.923-7.648 4.923.828 1.164 1.498 2.55 2.021 4.073a16.004 16.004 0 005.627-8.996zM1.234 30.151l-.83-2.581 8.485-5.548 7.118 15.095v2.882H16C9.35 40 3.649 35.935 1.234 30.151z",
    fill: "#4D4D4D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.841 29.967l.705-2.198c.018-.07.036-.138.05-.21l-8.47-5.538-7.12 15.095v2.882c6.718-.002 12.466-4.151 14.835-10.03z",
    fill: "#333"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.772 22.021l7.229 15.54 7.227-15.54H8.772z",
    fill: "#CCC"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.11 33.5L16 37.561l1.89-4.063-1.368-2.574h-.03l1.037-.993.158-.135-.563-2.89c-.1-.1-.082-.113-.204-.113l-.92.19-.922-.19c-.122 0-.103.012-.203.113l-.563 2.89.157.135 1.037.994h-.03l-1.366 2.573z",
    fill: "#C30"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 37.562l1.89-4.063-1.368-2.574h-.03l1.036-.993.159-.135-.563-2.89c-.1-.1-.082-.113-.204-.113l-.92.19v10.578z",
    fill: "#A32900"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M16.886 33.179h-3.47v.7h3.47v-.7z",
    fill: "#FC0"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.772 22.021l4.226 9.089H13l3.002-3 2.871-6.089h4.356l-4.226 9.089-3.001-3-2.875-6.089H8.772z",
    fill: "#fff"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.278 22.996l-.351 3.975 2.397 1.076-1.782 1.082 8.459 8.433-7.23-15.541-1.493.975zM24.72 22.996l.354 3.975-2.397 1.076 1.781 1.082-8.457 8.433 7.227-15.541 1.493.975z",
    fill: "#1A1A1A"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.008 38.259a.653.653 0 11-.002 1.306.653.653 0 01.002-1.306z",
    fill: "#B3B3B3"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.007 38.259a.653.653 0 010 1.308v-1.308z",
    fill: "gray"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.008 38.259a.653.653 0 11-.002 1.306.653.653 0 01.002-1.306z",
    fill: "#B3B3B3"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.007 38.259a.653.653 0 010 1.308v-1.308z",
    fill: "gray"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M26.517 34.194H21.02v.768h5.497v-.768z",
    fill: "#4D4D4D"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.02 34.194l2.243-2.247 1.272 1.273.506-.505 1.476 1.479H21.02z",
    fill: "#fff"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.864 12.96c-.792-1.029-.765-1.914.082-2.66 3.394.937 5.136 1.371 5.222 1.305-1.34 2.07-3.11 2.522-5.304 1.355zm-15.729 0c.792-1.029.765-1.914-.082-2.66-3.394.937-5.134 1.371-5.221 1.305 1.339 2.07 3.108 2.522 5.303 1.355z",
    fill: "#963"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.986 11.558c-1.664-1.962-1.905-3.076-.725-3.345 4.69.247 6.478-1.808 5.37-6.164L24.782 0c2.894 1.903 4.188 4.512 3.794 7.818-.224 1.872-2.781 3.117-7.59 3.74zm-9.972 0c1.664-1.962 1.905-3.076.725-3.345C7.05 8.46 5.26 6.405 6.367 2.05L7.22 0C4.323 1.903 3.03 4.512 3.424 7.818c.223 1.872 2.78 3.117 7.59 3.74z",
    fill: "#4D4D4D"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 28.11L5.455 19.228c.182-4.706 1.082-8.618 2.701-11.738 1.573-1.842 4.178-2.367 7.846-2.367 3.665 0 6.27.525 7.842 2.367 1.619 3.12 2.52 7.033 2.703 11.738L16 28.11z",
    fill: "#C93"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.001 5.122c3.665 0 6.27.525 7.842 2.367 1.619 3.12 2.52 7.033 2.703 11.738L16 28.11V5.12z",
    fill: "#A37A29"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.51 17.919c.288-4.128 1.164-7.604 2.63-10.43.063-.074.127-.146.193-.214 4.049-3.221 3.211 7.335 3.253 8.664.424 1.526-.568 2.46-2.977 2.8-1.25-.188-2.283-.462-3.1-.82zM26.49 17.919c-.288-4.128-1.165-7.604-2.63-10.43a5.27 5.27 0 00-.194-.214c-4.049-3.221-3.212 7.335-3.252 8.664-.425 1.526.568 2.46 2.978 2.8 1.249-.188 2.28-.462 3.099-.82z",
    fill: "#963"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 28.11L5.455 19.228c.044-1.143.131-2.24.26-3.289h20.57c.13 1.05.217 2.146.262 3.289L16 28.11z",
    fill: "#963"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.001 28.11l-6.927-5.832 2.727-4.136c-.105-.968-.116-1.702-.038-2.202h1.765c.649.69 1.472 1.824 2.472 3.405.998-1.581 1.82-2.715 2.47-3.405h1.766c.078.5.066 1.234-.038 2.202 1.817 2.757 2.727 4.135 2.727 4.135l-6.924 5.834z",
    fill: "#85592B"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.802 18.14c.055-1.41 2.25-.08 3.262.609a7.513 7.513 0 00.962.635c.356-.198.703-.431 1.042-.698 1.048-.703 3.116-1.913 3.17-.545 2.989-5.338-11.574-5.326-8.436 0z",
    fill: "#1A1A1A"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 14.423c1.344 0 2.434.535 2.434 1.193 0 .66-1.09 1.194-2.433 1.194-1.346 0-2.436-.535-2.436-1.194.001-.658 1.09-1.193 2.436-1.193z",
    fill: "#666"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 21.981c-3.415 0-4.031-.613-3.86-1.95.045 1.119 1.33 1.379 3.86 1.379s3.815-.26 3.86-1.379c.17 1.337-.445 1.95-3.86 1.95zM21.8 11.816c-.632-.027-1.186.487-1.391 1.145-.508-4.27 3.44-4.447 4.324-1.645-.744.455-1.545.561-2.933.5zm-11.6 0c.632-.027 1.187.487 1.391 1.145.508-4.27-3.442-4.447-4.324-1.645.744.455 1.545.561 2.933.5z",
    fill: "#1A1A1A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwsLogoSm);

var SWSLogoIconSimple = forwardRef((props, ref) => jsx(ForwardRef, Object.assign({
  ref: ref
}, props)));

export { Alert, AlertAction, Bones, Box, ButtonWithDropdown, Grid, Heading, SWSLogoIcon, SWSLogoIconSimple, Tab, TabList, TabPanel, Text, Toggle, ToggleButton, tabCSS };
